// this file lists the help videos displayed on  devices

export const helpVideos = [
    { text: "", link: "_", device: "" },

    { text: "-Explainer: Financial Markets Are Seasonal - Video",  link: "/explain", device: "" },

    { text: "-What is Seasonality in Financial Markets? - blog",  link: "/what-is-seasonality-in-financial-instruments/", device: "" },

    { text: "-What is Trade Seasonals? - blog",  link: "/what", device: "" },

    { text: "-Reports - Excel xlsx",  link: "/reports", device: "" },

    { text: "", link: "_", device: "" },

    { text: "Overview of Trade Seasonal Dashboard on desktop",      link: "https://youtu.be/STqr7EJCxME", device: "desktop" },    //https://www.youtube.com/watch?v=STqr7EJCxME
    { text: "Overview of Trade Seasonal Dashboard on iPad",         link: "https://youtu.be/qm5ZNhV4QeE", device: "ipad" },       //https://www.youtube.com/watch?v=qm5ZNhV4QeE
    { text: "Overview of Trade Seasonal Dashboard on smart phone",  link: "https://youtu.be/XtKYqYPmW4M", device: "smartphone" }, //https://www.youtube.com/watch?v=XtKYqYPmW4M

    { text: "", link: "", device: "" },

    { text: "Advanced Help Videos", link: "", device: "" },

    { text: "", link: "", device: "" },

    { text: "Video 1/14  - Introduction",                               link: "https://youtu.be/E-4te_Q0_7Q", device: "" },
    { text: "Video 2/14  - The Layout",                                 link: "https://youtu.be/FStxAmQK1vI", device: "" },
    { text: "Video 3/14  - Opportunities Table Basics",                 link: "https://youtu.be/xKSav0JMswY", device: "" },
    { text: "Video 4/14  - Opportunities Table Filter & Sort",          link: "https://youtu.be/BlTFhENOulg", device: "" },
    { text: "Video 5/14  - Opportunities Table Expand Feature",         link: "https://youtu.be/7_uI-DU1WB4", device: "" },
    { text: "Video 6/14  - Seasonal Viewer"                   ,         link: "https://youtu.be/AcpFw0C32wM", device: "" },
    { text: "Video 7/14  - Seasonal Viewer Profit Barchart"   ,         link: "https://youtu.be/IMEugMcgQ-g", device: "" },
    { text: "Video 8/14  - Seasonal Viewer MFE MAE"           ,         link: "https://youtu.be/bdH8NAvZrsM", device: "" },
    { text: "Video 9/14  - Seasonal Chart"                    ,         link: "https://youtu.be/XWrrnXJuoKY", device: "" },
    { text: "Video 10/14  - Seasonal Chart Trends"             ,         link: "https://youtu.be/ehm1oiRWk8U", device: "" },
    { text: "Video 11/14 - Seasonal Chart Find Opportunities",          link: "https://youtu.be/RwOiQNmjVcE", device: "" },
    { text: "Video 12/14 - Seasonal Report",                            link: "https://youtu.be/gpHCEfRLvjk", device: "" },
    { text: "Video 13/14 - Price Chart",                                link: "https://youtu.be/cMz2_nvTzTI", device: "" },
    { text: "Video 14/14 - Advanced Filter in Seasonal Viewer",         link: "https://youtu.be/1o-2gfrMICM", device: "" },
    
    { text: "", link: "_", device: "" },                                                      
]

 